import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  companyName?: string;
};

export const ConfirmDeleteSubscriptionDialog = ({
  open,
  onClose,
  onDelete,
  companyName,
}: Props) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>サブスクリプションを削除しますか？</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {companyName && `「${companyName}」の`}
          サブスクリプションを削除します。この操作は元に戻すことができません。
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
        <Button variant="contained" color="error" onClick={onDelete}>
          削除
        </Button>
      </DialogActions>
    </Dialog>
  );
};
